<template>
	<div class="content-box-wrapper margin-bottom-xs-2 module">
		<div class="content-box-header">
			<div class="row align-items-center">
				<div class="col-12 col-md">
					<a
						href="#"
						class="text-decoration-none"
						@click.prevent="goToDashboard"
						><Icon
							class="margin-right-xs-1 icon-17"
							:icon="'arrow-thin-left'"
						/>
						Dina moduler</a
					>
				</div>
				<div class="col">
					<h2
						class="content-box-header__headline text-17 text-md-center"
						v-html="module.name"
					></h2>
				</div>
				<div class="d-none d-md-block col"></div>
				<div class="col-12 py-2">
					<ModuleProgressBar :module="module" />
				</div>
			</div>
		</div>
		<div
			class="module-description content-box-padding padding-top-xs-2 padding-bottom-xs-2 padding-top-md-4 padding-bottom-md-4"
			:style="'background-image: url(' + module.image + ');'"
			:class="module.color_scheme"
			v-html="module.description"
		></div>
		<Resource />
	</div>
</template>
<script>
import Resource from "./Resource.vue";
import ModuleProgressBar from "./../partials/ModuleProgressBar.vue";
import Icon from "./../partials/Icon.vue";

export default {
	name: "Module",
	props: [],
	components: { Resource, ModuleProgressBar, Icon },
	computed: {
		module() {
			return this.$store.state.activeModule;
		}
	},
	methods: {
		goToDashboard() {
			this.$store.dispatch("goToDashboard");
		}
	},
	mounted() {}
};
</script>